import { memo } from "react";
import ShareIcon from "@/common/images/icons/share.svg?react";
import { copyLink, getGifLink } from "@/common/utils/share";
import "./ManageLinkItem.scss";

interface IManageLinkItem {
  linkId: string;
}

export const ManageLinkItem: React.FC<IManageLinkItem> = memo(({
  linkId
}) => {
  const onShareLink = () => {
    copyLink(getGifLink(linkId));
  };

  return (
    <div className="ManageLinkItem">
      <button type="button" className="ManageLinkItem-ShareBtn" onClick={onShareLink} aria-label="Share Link"><ShareIcon /></button>
      <span>{getGifLink(linkId)}</span>
    </div>
  );
});
